var React = require('react');

function HamburgerOpened (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.6"},[React.createElement("path",{"d":"M1 17.5L16 1.5","stroke":"#382E2B","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M16 17.5L1 1.5","stroke":"#382E2B","strokeWidth":"2","strokeLinecap":"round","key":1})]));
}

HamburgerOpened.defaultProps = {"width":"17","height":"19","viewBox":"0 0 17 19","fill":"none"};

module.exports = HamburgerOpened;

HamburgerOpened.default = HamburgerOpened;
